export function currentExtension(state = null, action) {
	switch (action.type) {
		case 'SWITCH_EXTENSION':
			return JSON.parse(JSON.stringify(action.extension))
		default:
			return state
	}
}